import React from 'react';
import numeral from 'numeral';
import DnDTextInput from 'components/lib/tables/dnd/DnDTextInput';
import DnDActionButtons from 'components/lib/tables/dnd/DnDActionButtons';
import styles from 'styles/components/lib/tables/dnd/dndRow.css';


const DnDRow = ({ hasChildren, hasParent, id, index, isDragged,
                  isEditing, isExpanded, isSelectedGroup, isTouchDevice, isUnactive,
                   parent, packages, row, ...props}) => {

    let canSelect = !hasChildren && (!props.parent || isEditing) && !isDragged;
    let cells = props.columns.map((col, key) => {
	    let maxWidth;

	    switch( col.grow ) {
		    case 0: maxWidth = `${col.width}px`;  break;
		    case 1: maxWidth = `10%`; break;
		    case 2: maxWidth = `20%`; break;
		    case 3: maxWidth = `30%`; break;
		    default:  maxWidth = `${col.width}px`; break;
	    }1

	    let style={
        flex: `${col.grow ? col.grow : 0} 0 ${col.width}px`,
	      maxWidth: maxWidth
      };

      if ( hasChildren && col.isOptional ) {
        return <DnDDormCell key={key} col={col} row={row}/>;
      } else if (col.selector && canSelect && !parent) {
        return <DnDSelector key={key}
                  col={col}
                  disable={isUnactive}
                  id={id}
                  index={index}
                  checked={props.isSelected}
                  isUnactive={isUnactive}
                  onSelect={props.onSelect}
                  style={style} />;
      } else if (col.name === 'name' && hasChildren) {
        return <DnDTextInput
                  key={key+id}
                  col={col}
                  clearError={props.clearError}
                  errorMessage={props.errorMessage}
                  row={row}
                  hasError={props.hasError}
                  handleEmptyName={props.handleEmptyName}
                  hintText="Enter Group Name"
                  isEditing={isEditing}
                  isNewBucket={props.isNewBucket}
                  name={props.name}
                  onSubmit={props.onEditDetails}
                  onNewNameChange={props.onNewNameChange}
                  style={style}
                  toggleRow={props.toggleRow}
                  isTouchDevice={props.isTouchDevice} />;
      } else if (col.name === 'actions') {
        return <DnDActionButtons
                  key={key}
                  buckets={props.buckets}
                  col={col}
                  isDragged={isDragged}
                  isEditing={isEditing}
                  isExpanded={isExpanded}
                  isNewBucket={props.isNewBucket}
                  isNewBucketCreation={props.isNewBucketCreation}
                  isOtherBucketEditing={props.isOtherBucketEditing}
                  isSelected={props.isSelected}
                  isSelectedGroup={isSelectedGroup}
                  isUnactive={isUnactive}
                  onAddToBucket={props.onAddToBucket}
                  onAddToNewBucket={props.onAddToNewBucket}
                  onClickEdit={props.onClickEdit}
                  onClickUngroup={props.onDelete}
                  onClickDelete={props.onDeleteChild}
                  onClickExpand={!isUnactive ? props.onClickExpand : undefined}
                  row={row}
                  style={style} />
      } else if (col.accessor) {
        if (packages && (col.name === 'priceLevelSection' || col.name === 'promotionName')) return null;
        return <DnDCell key={key}
                        col={col}
                        onClickUngroup={props.onClickUngroup}
                        packages={packages}
                        style={style}
                        row={row}
                        hasChildren={hasChildren}
                        hasParent={hasParent} />;
      } else if (hasChildren || !hasParent) {
        return <DnDCellHolder col={col} key={key} style={style} />;
      } else {
        return null;
      }
    });
    let disableDrag = hasParent || hasChildren || isUnactive;
    return (
      <ul  key={id}
           id={hasChildren ? `bucket${id}` : `row${id}`}
           className={parent ? styles.dndChild : (hasChildren ? `${styles.dndRow} groupContainer`: `${styles.dndRow}`) }
           draggable={!disableDrag}
           onClick={hasChildren && !isEditing ? props.toggleRow : null}
           onDragStart={(!hasChildren && !isDragged && !disableDrag) ?
             ((e) => props.onDragAdd(e, {key: id, index: index})) : undefined }
           onDragOver={props.onDragOver}
           onDragEnd={props.onDragEnd}
           style={hasChildren && isExpanded ?
             { marginTop: '10px', paddingRight: '0' }
             : { paddingRight: '0' }} >
        { cells }
      </ul>
    );
};

const DnDCell = ({col, hasChildren, hasParent, row, style, ...props}) => (
  <li className={styles[col.name]} style={style}>
    <h6 style={hasChildren
          ? col.name === 'total' ? {color: `#${row.color}`, fontSize: '14px', fontWeight: '600', textAlign: 'center'}
                                 : {fontSize: '14px', fontWeight: '600', textAlign: 'center'}
          : hasParent
            ? {textAlign: 'center'}
            : {}}>
      {col.name === 'total' ? '$' : ''}
      { typeof col.accessor === "string"
        ? (col.accessor === 'priceLevelSection' && hasChildren) || (col.accessor === 'promotionName' && hasChildren)
          ? ''
          : col.accessor === 'totalRevenue' ? numeral(row[col.accessor]).format('0,0.00') : row[col.accessor]
        : col.accessor(row)
      }
    </h6>
  </li>
);

const DnDCellHolder = ({col, style, ...props}) => (
  <li className={styles.dndCell} style={style} />
);

const DnDDormCell = ({col, style, ...props}) => (
  <li className={styles.cellHolder} style={{...style, justifyContent: 'center'}}> -.- </li>
);

// const DnDExpander = ({col, isExpanded, style, ...props}) => (
//   <li className={styles.dndCell} style={style} >
//     <button onClick={props.onClick}
//       style={{minWidth: '26px', minHeight: '26px', width: '26px', height: '26px', borderRadius: '50%', backgroundColor: '#E53939', color: '#fff', fontWeight: '600', fontSize: '14px', margin: '10px auto'}}>
//         {isExpanded ? '-' : '+'}
//     </button>
//   </li>
// );

const DnDSelector = ({checked, col, id, index,  isUnactive, style, ...props}) => {
  if (isUnactive) checked = false;
  return (
    <li className={styles.dndSelector}
      style={style}>
        <input
          type='checkbox'
          className="rowSelector"
          checked={ checked }
          data-key={id}
          data-index={index}
          onChange={!isUnactive ?
            ((e) => props.onSelect(e, {key:id, index: index}))
            : undefined }
          style={{cursor: 'pointer'}} />
    </li> );
};

export default DnDRow;



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDRow.js